import { useTranslation } from "react-i18next";
import styles from "./AllPayment.module.css";
import FooterButton from "../../components/ui/Button/FooterButton";
import { WarningBox } from "./_components/WarningBox";
import { useFetchInvoice } from "../../features/loans/hooks/useFetchInvoice";
import { INVOICE_FILE_NAME } from "../../features/loans/hooks/useFetchInvoice";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { formatThaiDate } from "../../utils/util";
import { useState } from "react";
import { formatMoneyNumber } from "../../utils/util";
import { getUnpaidInstallmentSummary } from "../../utils/loan";
import dayjs from "dayjs";

export const AllPayment = ({ loan }) => {
  const { t } = useTranslation("myLoanInvoice");
  const isDesktop = useIsDesktop();
  const isLineBrowser = /Line\/[0-9.]+/.test(navigator.userAgent);
  const [now] = useState(dayjs(new Date()).format("DD/MM/YYYY"));

  const { data: invoiceImageUrl, isFetching } = useFetchInvoice({
    loanId: loan?.loan_id,
  });

  async function handleDownloadInvoice() {
    // Check if running in LINE's LIFF browser
    const isLineBrowser = /Line/i.test(navigator.userAgent);

    if (isLineBrowser) {
      const pathAndQuery = window.location.pathname + window.location.search;
      const host = "auunjai.com"; // Development host
      const baseUrl = `https://${host}${pathAndQuery}?openExternalBrowser=1`;

      // Detect platform (iOS or Android)
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      const isAndroid = /Android/i.test(navigator.userAgent);

      let externalUrl;

      if (isAndroid) {
        // Android: Use intent URL to open in Chrome
        externalUrl = `intent://${host}${pathAndQuery}#Intent;scheme=https;package=com.android.chrome;end`;
      } else if (isIOS) {
        // iOS: Show a prompt to the user to open in Safari
        const userConfirmed = window.confirm(
          "This page works better in Safari. Would you like to open it in Safari now?"
        );
        if (userConfirmed) {
          externalUrl = baseUrl;
        } else {
          // If user cancels, stay on the current page
          return;
        }
      } else {
        // Fallback for other platforms
        externalUrl = baseUrl;
      }

      // Perform the redirect
      window.location.href = externalUrl;
      return;
    }

    // Otherwise download normally
    const a = document.createElement("a");
    a.href = invoiceImageUrl;
    a.download = `${INVOICE_FILE_NAME}-${loan?.loan_name}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const unpaidInstallmentSummary = getUnpaidInstallmentSummary(loan);

  return (
    <div className={styles.container}>
      <div className={styles.paymentSection}>
        <div className={styles.paymentBox}>
          <div className={styles.paymentTitle}>{t("summaryDate")}</div>
          <div className={styles.paymentValue}>
            {formatThaiDate(
              unpaidInstallmentSummary?.latestInstallment?.installment_date
            )}
          </div>
        </div>
        <div className={styles.paymentBox}>
          <div className={styles.paymentTitle}>{t("totalDue")}</div>
          <div className={styles.paymentValue}>
            {formatMoneyNumber(unpaidInstallmentSummary?.total)}
          </div>
        </div>
        <p className={styles.dataAsOf}>
          {t("dataAsOf")} : {now}
        </p>
      </div>
      <WarningBox />
      {!isLineBrowser && isDesktop && (
        <div className={styles.receiptSection}>
          <embed
            src={invoiceImageUrl}
            type="application/pdf"
            className={styles.pdf}
          />
        </div>
      )}
      <FooterButton
        submitButtonTitle={t("downloadReceipt")}
        submitButtonIcon={
          <img
            src="/assets/img/ci/icon/ico-download-white.svg"
            alt="download"
            style={{
              marginRight: 4,
              verticalAlign: "middle",
            }}
          />
        }
        disabledSubmit={
          !unpaidInstallmentSummary?.latestInstallment || isFetching
        }
        onSubmit={handleDownloadInvoice}
      />
    </div>
  );
};
